import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BrowserRouter } from "react-router-dom";
import './assets/css/font/Font.css';
import './assets/css/variables/Variables.css'
import  { MyContextProvider } from "./context/MyContext";
import ScrollToTop from "./components/general/scrollToTop/ScrollToTop";
import { initTokenRefresh } from "./utils/AuthRefresh";
// app start hote hi token refresh ka process start karte hain
initTokenRefresh();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
        <MyContextProvider>
          <ScrollToTop/>
          <App />
        </MyContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
